import React, { Component } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import CannyAttribution from 'common/CannyAttribution';
import { CompanyContext } from 'common/containers/CompanyContainer';
import { SSOTokenContext } from 'common/containers/SSOTokenContainer';
import { TintColorContext } from 'common/containers/TintColorContainer';
import devURL from 'common/util/devURL';
import getCannyOrigin from 'common/util/getCannyOrigin';
import queryString from 'common/util/queryString';
import withContexts from 'common/util/withContexts';

import 'css/components/changelog/widget/_ChangelogWidgetFooter.scss';

const encodeLabelURLNames = (labelURLNames) => {
  return labelURLNames.length > 0 ? encodeURIComponent(labelURLNames.join('_')) : undefined;
};

class ChangelogWidgetFooter extends Component {
  static propTypes = {
    changelog: PropTypes.shape({
      hasRSSFeed: PropTypes.bool,
      labels: PropTypes.arrayOf(
        PropTypes.shape({
          _id: PropTypes.string,
          urlName: PropTypes.string,
        })
      ),
    }),
    company: PropTypes.object,
    fullscreenMode: PropTypes.bool,
    ssoToken: PropTypes.string,
    tintColor: PropTypes.string,
    labelIDs: PropTypes.array,
  };

  getRSSLink() {
    const { company, ssoToken } = this.props;

    const params = {
      ...(ssoToken && { ssoToken }),
    };

    const link = devURL(
      `${getCannyOrigin(company)}/api/changelog/feed.rss${queryString.stringify(params)}`
    );
    return {
      href: link,
      label: 'RSS',
    };
  }

  renderSeeAll() {
    const { changelog, company, ssoToken, labelIDs } = this.props;

    const labelParams = new Set();
    if (labelIDs && labelIDs.length) {
      labelIDs.forEach((labelID) => {
        const labelName = changelog.labels.find((label) => label._id === labelID)?.urlName;
        if (labelName) {
          labelParams.add(labelName);
        }
      });
    }

    const changelogQueryParams = queryString.stringify({
      ...(ssoToken ? { ssoToken } : {}),
      ...(labelParams.size ? { labels: encodeLabelURLNames(Array.from(labelParams)) } : {}),
    });

    const url = devURL(`${getCannyOrigin(company)}/changelog${changelogQueryParams}`);

    return (
      <a className="seeAll" href={url} rel="noopener" target="_blank">
        See&nbsp;all&nbsp;changes
      </a>
    );
  }

  render() {
    const { changelog, fullscreenMode } = this.props;

    return (
      <div
        className={classnames('changelogWidgetFooter', {
          fullscreenMode,
        })}>
        <CannyAttribution
          externalLink={true}
          links={changelog?.hasRSSFeed ? [this.getRSSLink()] : []}
          showCompanyLinks={false}
          source="changelog_widget"
        />
        {this.renderSeeAll()}
      </div>
    );
  }
}

export default withContexts({
  company: CompanyContext,
  ssoToken: SSOTokenContext,
  tintColor: TintColorContext,
})(ChangelogWidgetFooter);
